import { render, staticRenderFns } from "./detailCase.vue?vue&type=template&id=4b40eb74&scoped=true"
import script from "./detailCase.vue?vue&type=script&lang=js"
export * from "./detailCase.vue?vue&type=script&lang=js"
import style0 from "./detailCase.vue?vue&type=style&index=0&id=4b40eb74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b40eb74",
  null
  
)

export default component.exports